import * as React from 'react';
import { Company } from '../company';

const cardBackground = (company: Company) => {
  return (company.theme && company.theme.background) || '#1D1D1D';
};

const cardBody = (company: Company) => {
  return (company.theme && company.theme.body) || '#FFFFFF';
};

const cardKey = (company: Company) => {
  return (company.theme && company.theme.key) || '#FFFFFF';
};

const location = (company: Company) => {
  if (!company.location.city) {
    return company.location.country;
  }

  return [company.location.city, company.location.country].join(', ');
};

export interface Props {
  company: Company;
}

export const CompanyInSituAppPreview = ({ company }: Props) => (
  <div className={'previewWrapper'}>
    <div className={'previewWindow'} style={{ backgroundColor: 'black' }}>
      <h2 className="f2 lh-title white mh3 mv4">Discover</h2>
      <h3 className="f3 lh-title white mh3 mv2">Featured this week</h3>
      <p className="lh-copy mh3 mv2 white-70">
        {company.name} has become a most brewed coffee roaster this month.
      </p>
      <div className="ma3" key={JSON.stringify(company)}>
        <div className="db relative br4 overflow-hidden shadow-4">
          <div className="aspect-ratio aspect-ratio--1x1">
            <div
              className="aspect-ratio--object cover"
              style={{
                backgroundImage: `url(${company.image_identifier ||
                  '/images/favourite.png'})`,
                backgroundPosition: 'center',
              }}
            />
          </div>
          <div style={{ backgroundColor: cardBackground(company) }}>
            <h5
              className="ma0 ph3 pt3 ttu f7"
              style={{ color: cardBody(company), opacity: 0.5 }}
            >
              {location(company)}
            </h5>
            <h3
              className="ma0 ph3 pb3 pt2 f4"
              style={{ color: cardKey(company) }}
            >
              {company.name}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default CompanyInSituAppPreview;
